import * as types from './mutation-type'

export default {
  [types.HYDRATE_NOTIFICATIONS](state, { cacheKey, cached }) {
    state.cacheKey = cacheKey
    state.messages = cached ? cached.messages : []
    state.totalCount = cached ? cached.totalCount : 0
    state.unreadCount = cached ? cached.unreadCount : 0
    state.fetchedAt = cached ? cached.fetchedAt : 0
    state.isLoading = false
    state.error = null
    state.readError = null
    state.revision++
  },
  [types.GET_NOTIFICATIONS_BEGIN](state) {
    state.isLoading = true
    state.error = null
  },
  [types.GET_NOTIFICATIONS_SUCCESS](state, data) {
    state.isLoading = false
    if (data) {
      state.messages = data.messages
      state.totalCount = data.totalCount
      state.unreadCount = data.unreadCount
      state.fetchedAt = data.fetchedAt
      if (state.readError && !data.messages.some(message => message.id === state.readError.messageId)) {
        state.readError = null
      }
    }
    state.error = null
  },
  [types.GET_NOTIFICATIONS_ERROR](state, error) {
    state.isLoading = false
    state.error = error
  },
  [types.MARK_NOTIFICATION_READ_BEGIN](state, messageId) {
    if (state.readError && state.readError.messageId === messageId) {
      state.readError = null
    }
  },
  [types.MARK_NOTIFICATION_READ_SUCCESS](state, message) {
    const index = state.messages.findIndex(item => item.id === message.id)
    if (index !== -1) {
      if (state.messages[index].MessageReads?.length) {
        return
      }

      state.messages.splice(index, 1, { ...message, isSeen : true })
    }
    state.unreadCount = Math.max(0, state.unreadCount - 1)
    state.revision++
    if (state.readError && state.readError.messageId === message.id) {
      state.readError = null
    }
  },
  [types.MARK_NOTIFICATION_READ_ERROR](state, { messageId, error }) {
    state.readError = { messageId, error }
  }
}
